import ShowActions from 'flux/actions/ShowActions';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import { OrderedMap, Map } from 'immutable';
import VisibilityMenuItem from 'main/components/show/grid/columnHeaderCell/visibilityMenuItem';
import WidthMenuItem from 'main/components/show/cuesheet/columnHeaderCell/widthMenuItem';
import {
  NoteColumnHeaderTitle,
  ItemColumnHeaderTitle,
  DescriptionColumnHeaderTitle,
  ColumnWidthTokens,
} from 'flux/stores/cuesheet/CuesheetConstants';
import { humanize } from 'underscore.string';

import React from 'react';
import role from 'shared/lib/role';

export default {
  getUtilityColumnOptions(context, state, divider, user) {
    let { teamId, eventId, showId } = context.router.state.params;

    let hasEventAdmin = role.hasEventAdminRole(user, teamId, eventId);

    let { showSettings, userSettings } = state;

    let displayItemNumbers = showSettings.get('displayItemNumbers'),
      displayItemNumbersVerb = displayItemNumbers ? 'Hide' : 'Show',
      displayItemNumbersNextVal = displayItemNumbers ? false : true,
      displayStartTimes = showSettings.get('displayStartTime'),
      displayStartTimesVerb = displayStartTimes ? 'Hide' : 'Show',
      displayStartTimesNextVal = displayStartTimes ? false : true,
      displayDurations = showSettings.get('displayDuration'),
      displayDurationsVerb = displayDurations ? 'Hide' : 'Show',
      displayDurationsNextVal = displayDurations ? false : true,
      displayPresetDurations = showSettings.get('displayPresetDuration'),
      displayPresetDurationsVerb = displayPresetDurations ? 'Hide' : 'Show',
      displayPresetDurationsNextVal = displayPresetDurations ? false : true,
      displayTitles = showSettings.get('displayItemTitles'),
      displayTitlesVerb = displayTitles ? 'Hide' : 'Show',
      displayTitlesNextVal = displayTitles ? false : true,
      displayDescriptions = showSettings.get('displayItemDescriptions'),
      displayDescriptionsVerb = displayDescriptions ? 'Hide' : 'Show',
      displayDescriptionsNextVal = displayDescriptions ? false : true,
      displayNotes =
        userSettings && !userSettings.getIn(['noteColumn', 'hidden']),
      displayNotesVerb = displayNotes ? 'Hide' : 'Show',
      displayType = showSettings.get('displayType');

    return OrderedMap({
      toggleItemNumber: Map({
        content: (
          <VisibilityMenuItem verb={displayItemNumbersVerb} label="Item #'s" />
        ),
        hidden: !hasEventAdmin,
        onClick: () => {
          ShowActions.saveField(
            teamId,
            eventId,
            showId,
            'displayItemNumbers',
            displayItemNumbersNextVal,
            displayType,
          );
        },
      }),
      toggleTitle: Map({
        content: (
          <VisibilityMenuItem
            verb={displayTitlesVerb}
            label={ItemColumnHeaderTitle}
          />
        ),
        hidden: !hasEventAdmin,
        onClick: () => {
          ShowActions.saveField(
            teamId,
            eventId,
            showId,
            'displayItemTitles',
            displayTitlesNextVal,
            displayType,
          );
        },
      }),
      toggleDescription: Map({
        content: (
          <VisibilityMenuItem
            verb={displayDescriptionsVerb}
            label={DescriptionColumnHeaderTitle}
          />
        ),
        hidden: !hasEventAdmin,
        onClick: () => {
          ShowActions.saveField(
            teamId,
            eventId,
            showId,
            'displayItemDescriptions',
            displayDescriptionsNextVal,
            displayType,
          );
        },
      }),
      toggleStartTime: Map({
        content: (
          <VisibilityMenuItem verb={displayStartTimesVerb} label="Start Time" />
        ),
        hidden: !hasEventAdmin,
        onClick: () => {
          ShowActions.saveField(
            teamId,
            eventId,
            showId,
            'displayStartTime',
            displayStartTimesNextVal,
            displayType,
          );
        },
      }),
      toggleDuration: Map({
        content: (
          <VisibilityMenuItem verb={displayDurationsVerb} label="Duration" />
        ),
        hidden: !hasEventAdmin,
        onClick: () => {
          ShowActions.saveField(
            teamId,
            eventId,
            showId,
            'displayDuration',
            displayDurationsNextVal,
            displayType,
          );
        },
      }),
      togglePresetDuration: Map({
        content: (
          <VisibilityMenuItem
            verb={displayPresetDurationsVerb}
            label="Preset Time"
          />
        ),
        hidden: !hasEventAdmin,
        onClick: () => {
          ShowActions.saveField(
            teamId,
            eventId,
            showId,
            'displayPresetDuration',
            displayPresetDurationsNextVal,
            displayType,
          );
        },
      }),
      toggleNote: this.getNoteColumnOption(
        divider,
        displayNotes,
        displayNotesVerb,
      ),
    });
  },

  getNoteColumnOption(divider, displayNotes, displayNotesVerb) {
    return Map({
      divider: divider ? true : false,
      content: (
        <VisibilityMenuItem
          verb={displayNotesVerb}
          label={NoteColumnHeaderTitle}
        />
      ),
      onClick: () => {
        if (displayNotes) {
          CuesheetColumnActions.hideNoteColumn();
        } else {
          CuesheetColumnActions.showNoteColumn();
        }
      },
    });
  },

  getWidthColumnOptions(hasEventAdmin, currentWidth, onClick) {
    let config = {};

    ColumnWidthTokens.forEach((width, i) => {
      config[`setWidth_${width}`] = Map({
        hidden: !hasEventAdmin,
        divider: width === 'scriptWide',
        content: (
          <span className="grid-column-menu grid-column-menu-width">
            <WidthMenuItem
              keyModifier={i > 2 ? 'widthShrink' : 'widthGrow'}
              label={humanize(width)}
              currentWidth={currentWidth}
              width={width}
            />
          </span>
        ),
        onClick: () => onClick(width),
      });
    });

    return OrderedMap(config);
  },
};
